/**
 * 백테스팅 페이지
 */
import { useState } from 'react';
import KrBacktestPanel from '../components/backtest/KrBacktestPanel';
import UsBacktestPanel from '../components/backtest/UsBacktestPanel';
import { useBacktest } from '../hooks/useBacktest';
import './Backtest.css';
import './KrBacktest.css';

export default function Backtest() {
  const [market, setMarket] = useState<'US' | 'KR'>('US');
  const {
    symbol,
    setSymbol,
    strategy,
    setStrategy,
    period: backtestPeriod,
    setPeriod: setBacktestPeriod,
    initialCapital,
    setInitialCapital,
    strategies,
    backtestResult,
    comparisonResult,
    loading: backtestLoading,
    error: backtestError,
    activeTab,
    setActiveTab,
    handleRunBacktest,
    handleCompareStrategies,
  } = useBacktest();

  const interpretation = backtestResult ? interpretBacktest(backtestResult) : null;

  return (
    <div className="backtest-page-container">
      <div className="backtest-header">
        <h1 className="backtest-title">전략 백테스트</h1>
        <p className="backtest-market-note">
          화면은 공통 UX로 통합하고, 내부 엔진은 시장별로 다르게 사용합니다.
        </p>
      </div>

      <div className="backtest-tabs market-tabs" aria-label="시장 선택">
        <button
          onClick={() => setMarket('US')}
          className={`backtest-tab ${market === 'US' ? 'backtest-tab-active' : ''}`}
        >
          US / Alpaca paper
        </button>
        <button
          onClick={() => setMarket('KR')}
          className={`backtest-tab ${market === 'KR' ? 'backtest-tab-active' : ''}`}
        >
          KR / Toss replay
        </button>
      </div>

      {market === 'KR' ? (
        <KrBacktestPanel />
      ) : (
        <UsBacktestPanel
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          symbol={symbol}
          setSymbol={setSymbol}
          strategy={strategy}
          setStrategy={setStrategy}
          period={backtestPeriod}
          setPeriod={setBacktestPeriod}
          initialCapital={initialCapital}
          setInitialCapital={setInitialCapital}
          strategies={strategies}
          backtestResult={backtestResult}
          comparisonResult={comparisonResult}
          loading={backtestLoading}
          error={backtestError as string | null}
          interpretation={interpretation}
          onRun={handleRunBacktest}
          onCompare={handleCompareStrategies}
        />
      )}
    </div>
  );
}

function interpretBacktest(result: { total_return: number; max_drawdown: number; total_trades: number }) {
  if (result.total_trades < 5) return '거래 수가 적어 판단 신뢰도가 낮습니다.';
  if (result.max_drawdown <= -15) return '최대 낙폭이 커서 실전 반영 전 리스크 조정이 필요합니다.';
  if (result.total_return > 0) return '수익은 양호하지만 paper 성과와 함께 확인해야 합니다.';
  return '수익률이 음수라서 현재 조건에서는 적용을 보류하는 편이 안전합니다.';
}
